export default __webpack_public_path__ + "static/Concept_4-4ea9196f9ec719eae2d5bb326b3e7866.jpg";